var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "skadet bil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68672 8.77493L21.3133 10.1584L18.5063 5.24611L11.6692 6.81002L4.69173 2.8802L2.68672 8.77493ZM19.3083 15.2912C20.4311 15.2912 21.3133 14.4291 21.3133 13.3263C21.3133 12.2236 20.4311 11.3614 19.3083 11.3614C18.1855 11.3614 17.3033 12.2236 17.3033 13.3263C17.3233 14.4291 18.1855 15.2912 19.3083 15.2912ZM4.69173 15.2912C5.81454 15.2912 6.69674 14.4291 6.69674 13.3263C6.69674 12.2236 5.81454 11.3614 4.69173 11.3614C3.56892 11.3614 2.68672 12.2236 2.68672 13.3263C2.68672 14.4291 3.56892 15.2912 4.69173 15.2912ZM20.4511 4.54436L24 11.4215V20.5444C24 21.2862 23.4386 21.8276 22.6967 21.8276H21.3133C20.5714 21.8276 20.01 21.2662 20.01 20.5444V19.201H4.01003V20.5444C4.01003 21.2862 3.44862 21.8276 2.70677 21.8276H1.30326C0.561404 21.8276 0 21.2662 0 20.5444V10.0581L2.74687 2.19849C3.00752 1.39649 3.80952 0.915283 4.69173 0.915283L11.7694 4.86516L18.5263 3.26115C19.3885 3.26115 20.2105 3.7624 20.4511 4.54436Z",
    fill: "#0375D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamage);
export default __webpack_public_path__ + "static/media/damage.790f2317.svg";
export { ForwardRef as ReactComponent };